import { render, staticRenderFns } from "./FmTableMenu.vue?vue&type=template&id=4fa5f2a7&scoped=true&"
import script from "./FmTableMenu.vue?vue&type=script&lang=js&"
export * from "./FmTableMenu.vue?vue&type=script&lang=js&"
import style0 from "./FmTableMenu.vue?vue&type=style&index=0&id=4fa5f2a7&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa5f2a7",
  null
  
)

export default component.exports